// Chakra imports
import { Button, Flex, Text, useColorModeValue } from '@chakra-ui/react';
// Custom components
import Card from 'components/card/Card';
import FixedPlugin from 'components/fixedPlugin/FixedPlugin';
import Footer from 'components/footer/FooterAuthCentered';
import Navbar from 'components/navbar/NavbarAuth';
import { NAVIGATE } from 'constant/navigation';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

function AuthCentered(props) {
	//eslint-disable-next-line
	const { children, title, description, cardBottom, includeBtns, fullW } =
		props;
	const textColor = useColorModeValue('gray.900', 'gray.100');
	const bgColor = useColorModeValue('gray.100', 'gray.500');
	const navigate = useNavigate();
	const isLoggedIn = useSelector((state) => state.auth.isLoggedIn);
	return (
		<Flex
			direction='column'
			alignSelf='center'
			justifySelf='center'
			justifyContent='space-between'
			overflow='hidden'
			mx={{ base: '10px', lg: '0px' }}
			minH='100vh'
		>
			<FixedPlugin align='left' />
			<Navbar color={textColor} />
			{includeBtns && !isLoggedIn && (
				<Flex mb='20px' gap={'20px'} justifyContent={'center'}>
					<Button
						variant={'outline'}
						onClick={() => navigate(NAVIGATE.SIGN_IN)}
						whiteSpace={'wrap'}
					>
						Inicia sesión
					</Button>
					<Button
						variant={'outline'}
						onClick={() => navigate(NAVIGATE.SIGN_UP)}
						whiteSpace={'wrap'}
					>
						Regístrate
					</Button>
				</Flex>
			)}
			<Card
				w={{ base: '100%', md: fullW ? '100%' : 'max-content' }}
				h='max-content'
				mx='auto'
				width='100%'
				mb={cardBottom}
				bg={bgColor}
				p={{ base: '10px', md: '50px' }}
				pt={{ base: '10px' }}
			>
				{title && description ? (
					<Flex
						direction='column'
						textAlign='center'
						justifyContent='center'
						align='center'
						mb='30px'
					>
						<Text fontSize='4xl' fontWeight='bold'>
							{title}
						</Text>
						<Text
							fontSize='md'
							fontWeight='normal'
							mt='10px'
							mb='26px'
							w={{ base: '90%', sm: '60%', lg: '40%', xl: '333px' }}
						>
							{description}
						</Text>
					</Flex>
				) : null}
				{children}
			</Card>
			<Footer />
		</Flex>
	);
}
// PROPS

AuthCentered.propTypes = {
	description: PropTypes.string,
	title: PropTypes.string,
	image: PropTypes.any,
};

export default AuthCentered;
